import { render } from "./letter-topic-list.vue?vue&type=template&id=d04389d8"
import script from "./letter-topic-list.vue?vue&type=script&lang=js"
export * from "./letter-topic-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__